// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xARjz","modal":"Modal_modal__sIRP-","slide-down":"Modal_slide-down__D27bh"};